<style lang="less" scoped>
    .detail-mes-div{
        margin:16px 0px;
    }
    .detail-mes-div div{
        margin:4px 0px;
        color: #606266;
    }
    .detail-item-div div{
        width:350px;
    }
    .detail-title{
        display: inline-block;
        width:150px;
        text-align: right;
        margin-right: 5px;
    }
    .dialog-div{
        margin:0px 0px 10px 8px;
    }
    .table-btn{
        font-size: 9px;
        height:20px;
        line-height: 5.5px;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.detailBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">审核详情</div>
            <!-- <ZD-list-querys></ZD-list-querys> -->
            <div class="detail-mes-div">
                <div class="flex detail-item-div">
                    <div><span class="detail-title">运营商：</span>{{dealerCalcDto.dealerName}}</div>
                    <div><span class="detail-title">运营商ID：</span>{{dealerCalcDto.dealerNo}}</div>
                    <div><span class="detail-title">联系人：</span>{{dealer.contactName}}</div>
                    <div><span class="detail-title">联系电话：</span>{{dealer.contactPhone}}</div>
                </div>
                <div class="flex detail-item-div">
                    <div><span class="detail-title">未入账待审核金额：</span>{{dealerCalcDto.uncheckFee}}&nbsp;&nbsp;元</div>
                    <div><span class="detail-title">服务费：</span>{{dealerCalcDto.serviceFee}}&nbsp;&nbsp;元</div>
                    <div><span class="detail-title">待提现金额：</span>{{dealerCalcDto.unCashOutFee}}&nbsp;&nbsp;元</div>
                    <div><span class="detail-title">订单收入：</span>{{dealerCalcDto.actFee}}&nbsp;&nbsp;元</div>
                </div>
                <div class="flex detail-item-div">
                    <div><span class="detail-title">已提现金额：</span>{{dealerCalcDto.cashOutedFee}}&nbsp;&nbsp;元</div>
                    <div><span class="detail-title">充电量：</span>{{dealerCalcDto.chargeVal}}&nbsp;&nbsp;kW·h</div>
                </div>
                <div class="flex detail-item-div"></div>
            </div>
            <div class="page-action-btns flex">
                <!-- <button class="common-bg-button" @click="allReview()">运营批量审核</button> -->
                <div class="flex-1"></div>
                <div style="font-size:15px;line-height:32px;">审核状态：</div>
                <el-select v-model="queryInfo.fiReviewFlg" size="small" style="margin-right:10px;" placeholder="请选择" clearable>
                    <el-option value="U" label="未审核"></el-option>
                    <el-option value="Y"  label="审核通过"></el-option>
                    <el-option value="N"  label="审核未通过"></el-option>
                </el-select>
                <div style="font-size:15px;line-height:32px;">订单编号：</div>
                <el-input size="small" style="width:250px;margin-right:10px;" v-model="queryInfo.orderNo" placeholder="请输入订单编号" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <el-table :data="tableData" border stripe style="width: 100%" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="40" align="center" :selectable="canSel" fixed="left">
                    </el-table-column>
                    <el-table-column type="index" width="40" align="center">
                    </el-table-column>
                    <el-table-column prop="pileCode" label="桩编号" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="orderNo" label="订单编号" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="beginTime" label="开始时间" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="endTime" label="结束时间" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="payModeName" label="支付方式" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="orderPropertyName" label="订单属性" min-width="180" align="center">
                        <div slot-scope="scope">
                            <span v-if="scope.row.orderProperty == '01'">正常</span>
                            <span v-else>异常</span>
                        </div>
                    </el-table-column>
                    <el-table-column prop="chargeVal" label="充电量（kW·h）" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="tActFee" label="订单金额（元）" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="actPayFee" label="实收电费（元）" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="servFee" label="服务费（元）" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="unInCheckFee" label="未入账待审核金（元）" min-width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="fiReviewFlg" label="审核状态" min-width="180" align="center">
                        <div slot-scope="scope">
                            <span v-if="scope.row.fiReviewFlg=='Y'">通过</span>
                            <span v-else-if="scope.row.fiReviewFlg=='N'">未通过</span>
                            <span v-else>未审核</span>
                        </div>
                    </el-table-column>
                    <el-table-column  label="操作" min-width="100" align="center" fixed="right">
                        <div slot-scope="scope">
                            <el-button class="table-btn" v-if="scope.row.fiReviewFlg=='Y'" size="mini" type="primary" plain @click="handleTabBtnClick(scope.row)">查看</el-button>
                            <el-button class="table-btn" v-else size="mini" type="primary" plain @click="handleTabBtnClick(scope.row)">运营审核</el-button>
                        </div>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
        </div>
        <el-dialog title="运营审核" :visible.sync="dialogVisible" width="25%" @close="handleDialogClose()">
            <div class="dialog-div" v-if="flag">订单：{{orderObj.orderNo}}</div>
            <div class="dialog-div" v-if="flag">充电量：{{orderObj.chargeVal}}&nbsp;&nbsp;kW·h</div>
            <div class="dialog-div" v-if="flag">订单金额：{{orderObj.tActFee}}&nbsp;&nbsp;元</div>
            <div class="dialog-div" v-if="flag">实收电费：{{orderObj.actPayFee}}&nbsp;&nbsp;元</div>
            <el-form ref="form" :model="form" label-width="100px" :rules="pageConfig.formRules">
                <el-form-item label="审核结果：" prop="fiReviewFlg">
                    <el-radio-group v-model="form.fiReviewFlg">
                        <el-radio label="Y" :disabled="showFlag">通过</el-radio>
                        <el-radio label="N" :disabled="showFlag">不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" size="small" @click="handleOrderReview('form')" v-if="!showFlag">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {},  //初始化表单数据
                orderObj:{},    //审核运营弹窗表单数据
                showFlag:false,  //默认审核结果是否可以点击
                dialogVisible: false, //运营审核弹窗
                form:{
                    orderNos:[] //订单号
                },
                dealer:{},  //入账审核/财务审核 页面使用到的运营商数据
                dealerCalcDto:{}, //经销商信息
                flag:true,
            }
        },
        methods: {
            //初始化页面
            init() {
                this.getListData(this.pagination,true);
                this.dealer = this.$store.state.financeManageDealer;
                this.dealerCalcDto = this.dealer.dealerCalcDto;
                //this.dealerCalcDto.serviceFee  = this.dealerCalcDto.serviceFee.toFixed(2);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.dealerNo = _.$store.state.editId;//'DEAL1543895439624'
                _.queryInfo.pileType= '02';
                _.queryInfo.payStatus = '02';
                _.$H.get(_, _.$A.finance.list, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            //提交运营审核
            handleOrderReview(formName){
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(_.form.fiReviewFlg == 'Y'){
                            var obj = {
                                dealNo: _.orderObj.dealNo
                            }
                            _.$H.get(_, _.$A.dealer.findByDealNo, obj).then(res => {
                                if(res.data.data.profitShare == '0'){
                                    _.$U.error("请先填写分成金额")
                                    return;
                                }
                            })
                        }
                        if(_.flag){
                            _.form.orderNos = [];
                            _.form.orderNos.push(_.orderObj.orderNo);
                        }
                        _.$H.post(_, _.$A.finance.revieworders, _.form).then(res => {
                            _.dialogVisible = false;
                            _.init();
                        })
                    }
                });
            },
            //关闭弹窗
            handleDialogClose(){
                this.form.fiReviewFlg = '';
                this.$nextTick(()=>{
                    this.$refs['form'].clearValidate();
                })
            },
            //查看运营状态
            handleTabBtnClick(row){
                this.flag = true;
                if(row.fiReviewFlg == 'Y'){
                    this.form.fiReviewFlg = 'Y'
                    this.showFlag = true;
                }else{
                    this.form = {};
                    this.showFlag = false;
                }
                this.orderObj = row;
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    this.$refs['form'].clearValidate();
                })
            },
            //已注销
            allReview(){
                let _ = this;
                if(_.form.orderNos.length > 0){
                    this.flag = false;
                    _.dialogVisible = true;
                }else{
                    _.$U.error("请选择需要操作的对象")
                }
                
            },
            //选择单个表格
            canSel(row, index) {
                if (row.fiReviewFlg == "Y") {
                    return false;
                }
                return true;
            },
            //选中的订单
            handleSelectionChange(row){
                let _ = this;
                _.form.orderNos = [];
                row.forEach(item => {
                    _.form.orderNos.push(item.orderNo)
                })
                
            }
        },
        mounted() {
            this.init();
        }
    }
</script>